//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function normalizeAwb (value) {
  const awb = Array.isArray(value) ? value[0] : value;
  return typeof awb === 'string' ? awb.replace(/\s+/g, '') : '';
}

export default {
  name: 'shipment-tracking-form',
  data () {
    return {
      term: normalizeAwb(this.$route.query.awb),
      awbError: null,
    };
  },
  watch: {
    '$route.query.awb' (value) {
      this.term = normalizeAwb(value);
    },
  },
  methods: {
    search () {
      const term = normalizeAwb(this.term);

      if (!term) {
        this.awbError = this.$t('cabinet.menu.awbRequired');
        return;
      }

      this.awbError = null;

      if (normalizeAwb(this.$route.query.awb) === term) {
        this.$emit('search', term);
        return;
      }
      this.$router.push({
        name: 'tracking',
        query: { awb: term },
      });
    },
  },
};
